import { createIcon } from './Icon'

// Do not modify this file as it was auto-generated by update-icons.mjs
export default createIcon(
  'InformationIcon',
  'information',
  'M512 140.8c-169.662 0-307.2 137.539-307.2 307.2s137.538 307.2 307.2 307.2c169.661 0 307.2-137.538 307.2-307.2s-137.539-307.2-307.2-307.2zM512 38.4c226.217 0 409.6 183.383 409.6 409.6s-183.383 409.6-409.6 409.6c-226.216 0-409.6-183.384-409.6-409.6s183.384-409.6 409.6-409.6zM588.8 627.2c0 42.416-34.386 76.8-76.8 76.8-42.416 0-76.8-34.384-76.8-76.8s34.384-76.8 76.8-76.8c42.414 0 76.8 34.384 76.8 76.8zM512 499.2c28.278 0 51.2-22.923 51.2-51.2v-204.8c0-28.278-22.922-51.2-51.2-51.2-28.277 0-51.2 22.922-51.2 51.2v204.8c0 28.277 22.923 51.2 51.2 51.2z',
)
